export default __webpack_public_path__ + "static/media/hongdiem2.e1e0c38a.png";